import React from "react";
import './TabItem.css';
import { motion } from 'framer-motion';
import PostsList from "../../components/Blogs/HomePage";

const blogs = [
  {
    imgUrl: "./img/services/nlp-solutions/chatbots-and-virtual-assistants.png",
    imgAlt: "AI technology interface",
    title: "Top AI Trends to Watch in 2024",
    date: "2024-12-01",
    excerpt: "Explore the top AI trends revolutionizing industries and driving innovation in 2024."
  },
  {
    imgUrl: "./img/services/nlp-solutions/language-translation.jpg",
    imgAlt: "Artificial intelligence neural network",
    title: "Understanding Neural Networks for Beginners",
    date: "2024-11-20",
    excerpt: "Learn the basics of neural networks and how they power modern AI applications."
  },
  {
    imgUrl: "./img/services/nlp-solutions/content-moderation.png",
    imgAlt: "A robotic arm working on AI projects",
    title: "AI in Robotics: Transforming Automation",
    date: "2024-11-10",
    excerpt: "Discover how AI is advancing robotics and transforming automation processes."
  },
  {
    imgUrl: "./img/services/computer-vision/image-recognition.jpg",
    imgAlt: "A team working on AI models",
    title: "Collaborative AI: Building Smarter Teams",
    date: "2024-10-25",
    excerpt: "Understand how AI collaboration tools are enhancing teamwork and decision-making."
  },
  {
    imgUrl: "./img/services/computer-vision/object-detection.jpg",
    imgAlt: "AI-powered chatbot interface",
    title: "The Rise of AI Chatbots in Business",
    date: "2024-10-05",
    excerpt: "Explore how AI chatbots are reshaping customer interactions and business processes."
  },
  {
    imgUrl: "./img/services/computer-vision/augmented-reality.jpg",
    imgAlt: "AI processing on a computer chip",
    title: "AI in Edge Computing: Real-Time Insights",
    date: "2024-09-20",
    excerpt: "Learn how edge computing powered by AI is enabling real-time data analysis."
  },
  {
    imgUrl: "./img/services/machine-learning/recomendation-systems.jpg",
    imgAlt: "Artificial intelligence and big data",
    title: "Big Data Meets AI: Unlocking New Insights",
    date: "2024-09-01",
    excerpt: "Discover how AI is transforming big data into actionable insights across industries."
  },
  {
    imgUrl: "./img/services/machine-learning/nlp.jpg",
    imgAlt: "A futuristic AI design concept",
    title: "Ethics in AI: Addressing Key Challenges",
    date: "2024-08-15",
    excerpt: "Delve into the ethical considerations of AI development and deployment."
  },
  {
    imgUrl: "./img/services/ai-automation/chatbots-and-virtual-assistants.png",
    imgAlt: "AI-powered healthcare solutions",
    title: "AI in Healthcare: Revolutionizing Patient Care",
    date: "2024-08-05",
    excerpt: "Explore how AI is enhancing diagnostics, treatment, and patient care in healthcare."
  },
  {
    imgUrl: "./img/services/ai-automation/document-processing.jpg",
    imgAlt: "A smart city powered by AI",
    title: "AI for Smart Cities: Shaping the Future",
    date: "2024-07-20",
    excerpt: "Learn how AI technologies are driving the development of sustainable smart cities."
  }
];



const AI = () => {
  return (
    <motion.div
      key="div0"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 100 }}
      transition={{ duration: 0.7 }}
    >
      <PostsList data={blogs} />
    </motion.div>
  );
};

export default AI;
